import { API_URL, buildHeaders, handleResponse } from './apiClient';

export const fetchConfig = async (token) => {
  const response = await fetch(`${API_URL}/config`, {
    method: 'GET',
    headers: buildHeaders(token),
  });

  return handleResponse(response, 'Kunne ikke laste konfigurasjon.');
};

export const updateConfig = async (payload, token) => {
  const response = await fetch(`${API_URL}/config`, {
    method: 'PUT',
    headers: buildHeaders(token),
    body: JSON.stringify(payload),
  });

  return handleResponse(response, 'Kunne ikke lagre konfigurasjon.');
};

export const updateDeliveryPrices = async (payload, token) => {
  const response = await fetch(`${API_URL}/config/prices`, {
    method: 'PUT',
    headers: buildHeaders(token),
    body: JSON.stringify(payload),
  });

  return handleResponse(response, 'Kunne ikke lagre leveringspriser.');
};

export const uploadCompanyLogo = async (file, token) => {
  const formData = new FormData();
  formData.append('logo', file);

  const response = await fetch(`${API_URL}/config/logo`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}` },
    body: formData,
  });

  return handleResponse(response, 'Kunne ikke laste opp logo.');
};

export const uploadDashboardBg = async (file, token) => {
  const formData = new FormData();
  formData.append('bg', file);

  const response = await fetch(`${API_URL}/config/dashboard-bg`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}` },
    body: formData,
  });

  return handleResponse(response, 'Kunne ikke laste opp bakgrunnsbilde.');
};

export const uploadHeaderBg = async (file, token) => {
  const formData = new FormData();
  formData.append('bg', file);

  const response = await fetch(`${API_URL}/config/header-bg`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}` },
    body: formData,
  });

  return handleResponse(response, 'Kunne ikke laste opp header-bakgrunnsbilde.');
};

export const uploadRightPanelBg = async (file, token) => {
  const formData = new FormData();
  formData.append('bg', file);

  const response = await fetch(`${API_URL}/config/right-panel-bg`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}` },
    body: formData,
  });

  return handleResponse(response, 'Kunne ikke laste opp høyre panel-bakgrunnsbilde.');
};

export const removeDashboardBg = async (token) => {
  const response = await fetch(`${API_URL}/config/dashboard-bg`, {
    method: 'DELETE',
    headers: buildHeaders(token),
  });
  return handleResponse(response, 'Kunne ikke fjerne bakgrunnsbilde.');
};

export const removeHeaderBg = async (token) => {
  const response = await fetch(`${API_URL}/config/header-bg`, {
    method: 'DELETE',
    headers: buildHeaders(token),
  });
  return handleResponse(response, 'Kunne ikke fjerne header-bakgrunnsbilde.');
};

export const removeRightPanelBg = async (token) => {
  const response = await fetch(`${API_URL}/config/right-panel-bg`, {
    method: 'DELETE',
    headers: buildHeaders(token),
  });
  return handleResponse(response, 'Kunne ikke fjerne høyre panel-bakgrunnsbilde.');
};
